import React from 'react';

export interface SectionHeaderProps {
  number?: string;
  tag?: string;
  title: string;
  subtitle?: string;
  theme?: 'dark' | 'light';
  align?: 'left' | 'center';
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  number,
  tag,
  title,
  subtitle,
  theme = 'light',
  align = 'left',
  className = '',
}) => {
  const isDark = theme === 'dark';
  const isCenter = align === 'center';

  return (
    <div className={`mb-10 md:mb-14 ${isCenter ? 'text-center' : 'text-left'} ${className}`}>
      {(number || tag) && (
        <div
          className={`inline-flex items-center gap-2.5 text-xs font-semibold tracking-wider uppercase mb-3 px-3 py-1 rounded-full ${
            isDark
              ? 'bg-white/10 text-spaq-cyan-bright border border-white/15'
              : 'bg-spaq-cyan-pale text-spaq-cyan-dark border border-spaq-cyan/20'
          }`}
        >
          {number && <span className="font-mono font-bold">{number}</span>}
          {number && tag && <span className="opacity-40">•</span>}
          {tag && <span>{tag}</span>}
        </div>
      )}

      <h2
        className={`text-2xl sm:text-3xl md:text-[34px] font-bold tracking-tight leading-snug ${
          isDark ? 'text-white' : 'text-navy'
        }`}
      >
        {title}
      </h2>

      {subtitle && (
        <p
          className={`mt-4 text-base md:text-lg leading-relaxed max-w-3xl ${
            isCenter ? 'mx-auto' : ''
          } ${isDark ? 'text-slate-300' : 'text-navy-muted'}`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
